// extracted by mini-css-extract-plugin
export default {"Aside_Backdrop":"Aside_Aside_Backdrop__fzduv","Aside__Inner":"Aside_Aside__Inner__ru5Sp","Aside":"Aside_Aside__8-YLy","show":"Aside_show__8f6WH"};